/** Quiet autosave feedback shared by full-page and modal personal settings. */
import {Button} from '../../shared/ui/button';
import {usePreferences} from './PreferencesContext';
export function SaveStatus({status, error = '', retry}: {status: 'idle' | 'saving' | 'error'; error?: string; retry?: () => void}) {
  if (status === 'idle') return null;
  return <div role="status" aria-live="polite" className="flex flex-wrap items-center gap-3 py-2 text-sm text-muted-foreground">
    <span>{status === 'saving' ? 'Saving changes…' : error || 'Your changes could not be saved.'}</span>
    {status === 'error' && retry && <Button type="button" variant="outline" size="sm" onClick={retry}>Retry save</Button>}
  </div>;
}
export function SettingsSaveStatus() {
  const {saveStatus, saveError, retrySave} = usePreferences();
  return <SaveStatus status={saveStatus ?? 'idle'} error={saveError} retry={retrySave}/>;
}
